export default __webpack_public_path__ + "static/media/chart_line.11012de4.svg";